import { cva } from "class-variance-authority"

export const surfaceFieldBaseClassName =
  "border rounded-lg border-brand-ink/12 bg-brand-ink/[0.025] text-sm text-brand-ink shadow-xs placeholder:text-brand-ink/35 focus-visible:border-brand-accent focus-visible:ring-brand-accent/12 transition-all duration-200"

export const surfaceFieldControlClassName =
  "h-10 " + surfaceFieldBaseClassName

export const brandFieldBaseClassName =
  "border rounded-lg border-brand-ink/12 bg-brand-ink/[0.025] text-sm text-brand-ink shadow-xs placeholder:text-brand-ink/25 focus-visible:border-brand-accent focus-visible:ring-brand-accent/20 transition-all duration-200"

export const brandFieldControlClassName =
  "h-10 " + brandFieldBaseClassName

export const brandFieldLabelClassName =
  "text-[0.6875rem] font-semibold tracking-[0.1em] text-brand-ink/50 uppercase"

export const fieldMessageVariants = cva("mt-0.5 text-xs", {
  variants: {
    tone: {
      default: "text-brand-ink/35",
      success: "font-medium text-info",
      error: "text-destructive",
    },
  },
  defaultVariants: {
    tone: "default",
  },
})
